import { Text } from '@/ui-kit'
import { formatBytes, formatNumber } from '@/utils'
import { plural } from '@lingui/core/macro'
import { Plural, Trans } from '@lingui/react/macro'
import { CloudUpload, Star, Users, Zap } from 'lucide-react'
import type { Mission } from '../api/models'

type MissionStatsProps = {
  mission: Mission
}

export const MissionStats = ({ mission }: MissionStatsProps) => {
  const formatReward = (amount: number) =>
    mission.rewardType === 'usd' ? `$${formatNumber(amount, 2)}` : plural(amount, { one: '# point', other: '# points' })
  const reward = formatReward(mission.view.accruedReward)
  const extraReward = mission.type === 'WEBSITE_LOGIN' ? formatReward(mission.view.earnedPoints) : ''
  const uploadedSize = mission.type === 'FILE_UPLOAD' ? formatBytes(mission.view.uploadedBytes) : ''
  const joinedCount = mission.view.joined

  return (
    <>
      <div className="flex gap-6">
        {joinedCount !== undefined && <div className="text-gray-90 flex items-center gap-2">
          <Users size={15} className="text-gray-80 shrink-0" />
          <Text type="body2-regular">
            <Plural value={joinedCount} one="# joined" other="# joined" />
          </Text>
        </div>}
        {mission.type === 'FILE_UPLOAD' && mission.view.uploadedBytes > 0 && (
          <div className="text-gray-90 flex items-center gap-2">
            <CloudUpload size={15} className="text-gray-80 shrink-0" />
            <Text type="body2-regular">
              <Trans>Uploaded {uploadedSize}</Trans>
            </Text>
          </div>
        )}
      </div>
      {(mission.view.accruedReward > 0 || (mission.type === 'WEBSITE_LOGIN' && mission.view.earnedPoints > 0)) && (
        <>
          <div className="text-gray-70 mt-4 flex items-start gap-2">
            <Star size={16} className="text-green mt-1 shrink-0" />
            <Trans>You got {reward}</Trans>
          </div>
          {mission.type === 'WEBSITE_LOGIN' && mission.view.earnedPoints > 0 && (
            <div className="text-gray-70 flex items-start gap-2">
              <Zap size={16} className="text-green mt-1 shrink-0" />
              <Trans>You earned extra {extraReward}</Trans>
            </div>
          )}
        </>
      )}
    </>
  )
}
